import { render } from "./TypingBox.vue?vue&type=template&id=08c53711"
import script from "./TypingBox.vue?vue&type=script&lang=js"
export * from "./TypingBox.vue?vue&type=script&lang=js"

import "./TypingBox.vue?vue&type=style&index=0&id=08c53711&lang=scss"
script.render = render

export default script